import React, { CSSProperties, ReactElement } from "react";
import Modal from "@components/shared/modal";
import CloseIcon from "@components/svg/closeIcon";
import FormOfferModal from "@components/shared/formOfferModal/FormOfferModal";
import { FormProps } from "@components/shared/form";
import styles from "@components/shared/form/styles.module.scss";

interface FormInOfferModalProps {
    showFromInExitModal: boolean;
    handleCloseFormInsideExitModal: (options?: {
        wasFormSubmitted?: boolean;
    }) => void;
    modalVariables: Record<string, unknown>;
    formProps: FormProps;
}

export default function FormInOfferModal({
    showFromInExitModal,
    handleCloseFormInsideExitModal,
    modalVariables,
    formProps,
}: FormInOfferModalProps): ReactElement {
    return (
        <Modal
            active={showFromInExitModal}
            onClose={() => {
                handleCloseFormInsideExitModal();
            }}
            closeIcon={<CloseIcon />}
            width={500}
            modalClassName={styles["form-inside-offers-container"]}
            overflow="visible"
            closeButtonClassName={styles["form-inside-offers-close-button"]}
            pageBuilderVariables={modalVariables as CSSProperties}
        >
            {showFromInExitModal && (
                <FormOfferModal
                    {...formProps}
                    onInlineThankYouShown={() =>
                        handleCloseFormInsideExitModal({
                            wasFormSubmitted: true,
                        })
                    }
                />
            )}
        </Modal>
    );
}
